export const RENDER_CONTEXT = Object.freeze({
  SIGNUP_LOGIN_PAGE: 'signup_login_page',
  ONE_PAGE_STORE_POPUP: 'one_page_store_popup',
});
